import React, { ReactNode } from "react";

import { Column, Row, useCurrentViewPort, ViewPort } from "@gamedev-web/gamedev-sdk-core";

import * as styles from "./SplitPane.module.css";

type SplitPaneProps = Readonly<{
  children: ReactNode;
  rightPane?: ReactNode;
}>;

export const SplitPane = ({ children, rightPane }: SplitPaneProps) => {
  const currentViewPort = useCurrentViewPort();
  const shouldShowRightPane = rightPane && currentViewPort > ViewPort.MD;
  return (
    <Row className={styles.pageRow}>
      <Column className={styles.pageColumn}>
        <Row>
          <Column className={styles.leftPane}>{children}</Column>
          {shouldShowRightPane && <Column className={styles.rightPane}>{rightPane}</Column>}
        </Row>
      </Column>
    </Row>
  );
};
